import script from "./MemberInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberInformation.vue?vue&type=script&setup=true&lang=js"

import "./MemberInformation.vue?vue&type=style&index=0&id=8cd0cd76&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cd0cd76"]])

export default __exports__